const cardsData = [
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20scene%20with%20warm%20crimson%20red%20and%20gold%20accent%20lighting%2C%20mysterious%20atmosphere%2C%20abstract%20geometric%20shapes%2C%20cinematic%20mood%2C%20dark%20elegant%20background%2C%20luxurious%20texture%2C%20magazine-style%20composition&width=800&height=500&seq=card-img-1&orientation=landscape',
    title: '顶流塌房全记录：从巅峰到谷底只用了72小时',
    tag: '深度专题',
    tagColor: 'bg-primary-500',
    date: '2026-07-29',
    summary: '从警方通报到品牌解约，从粉丝崩溃到路人吃瓜，完整时间线梳理这场娱乐圈地震的每一个关键节点。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Editorial%20magazine%20style%20composition%20with%20warm%20amber%20golden%20lighting%2C%20abstract%20shapes%2C%20mysterious%20elegant%20atmosphere%2C%20dark%20sophisticated%20background%2C%20cinematic%20texture&width=800&height=500&seq=card-img-2&orientation=landscape',
    title: '网红经济大洗牌：2026上半年翻车事件大盘点',
    tag: '行业观察',
    tagColor: 'bg-accent-500',
    date: '2026-07-28',
    summary: '虚假宣传、偷税漏税、人设崩塌...盘点今年上半年最轰动的网红翻车事件及其背后的行业乱象。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20scene%20with%20warm%20terracotta%20and%20bronze%20tones%2C%20mysterious%20dramatic%20lighting%2C%20abstract%20elegant%20composition%2C%20dark%20luxurious%20background%2C%20high-end%20magazine%20aesthetic&width=800&height=500&seq=card-img-3&orientation=landscape',
    title: '综艺名场面背后的暗战：剪辑师揭秘行业潜规则',
    tag: '独家揭秘',
    tagColor: 'bg-secondary-500',
    date: '2026-07-27',
    summary: '那些让你笑到肚子痛或气到摔遥控器的名场面，有多少是真实发生，多少是精心设计？',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Artistic%20editorial%20photography%20with%20rich%20crimson%20and%20gold%20warm%20tones%2C%20abstract%20geometric%20elements%2C%20mysterious%20elegant%20mood%2C%20dark%20sophisticated%20background%2C%20luxurious%20texture&width=800&height=500&seq=card-img-4&orientation=landscape',
    title: '娱乐律师独家专访：明星解约官司里的那些门道',
    tag: '深度访谈',
    tagColor: 'bg-primary-500',
    date: '2026-07-26',
    summary: '天价违约金到底怎么算？艺人跳槽为什么总打官司？资深娱乐法律师为你一一解答。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20golden%20amber%20editorial%20scene%20with%20abstract%20shapes%2C%20dramatic%20cinematic%20lighting%2C%20mysterious%20elegant%20atmosphere%2C%20dark%20luxurious%20background%2C%20high-end%20magazine%20composition&width=800&height=500&seq=card-img-5&orientation=landscape',
    title: '从素人到顶流：选秀产业链的暴利与代价',
    tag: '产业分析',
    tagColor: 'bg-accent-500',
    date: '2026-07-25',
    summary: '一档选秀节目背后的资本运作、选手合约、粉丝经济，这条产业链远比舞台上的表演精彩。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题精选
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            深度挖掘热门话题，带你从吃瓜到懂瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardsData.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl overflow-hidden group cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-medium text-background-50 ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.summary}
                </p>
                <div className="text-xs text-foreground-400">{item.date}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}